import { render, staticRenderFns } from "./TeamPctBars.vue?vue&type=template&id=ab3c2a92&scoped=true"
import script from "./TeamPctBars.vue?vue&type=script&lang=ts"
export * from "./TeamPctBars.vue?vue&type=script&lang=ts"
import style0 from "./TeamPctBars.vue?vue&type=style&index=0&id=ab3c2a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3c2a92",
  null
  
)

export default component.exports